export default [{
  path: '/home',
  component: resolve => require(['@/components/base/view/main/main.vue'], resolve),
  children: [{
    path: '/file/num',
    component: resolve => require(['@/components/oa/view/basics/filenum/list.vue'], resolve) //文号管理
  }, {
    path: '/oa/official/receive/:self',
    component: resolve => require(['@/components/oa/view/official/receive/list/list.vue'], resolve) //收文
  },{
    path: '/oa/official/receiveHandle',
    component: resolve => require(['@/components/oa/view/official/receive/handle/list.vue'], resolve) //收文未处理
  }, {
    path: '/oa/official/receive/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/receive/edit/edit.vue'], resolve) //收文编辑
  }, {
    path: '/oa/official/receive/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/receive/view/view.vue'], resolve) //收文详情
  }, {
    path: '/oa/official/sendDoc/:self',
    component: resolve => require(['@/components/oa/view/official/sendDoc/list/list.vue'], resolve) //发文
  }, {
    path: '/oa/official/sendDoc/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/sendDoc/edit/edit.vue'], resolve) //发文编辑
  }, {
    path: '/oa/official/sendDoc/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/sendDoc/view/view.vue'], resolve) //发文详情
  },{
    path: '/oa/official/signDoc/:self',
    component: resolve => require(['@/components/oa/view/official/signDoc/list/list.vue'], resolve) //签报
  }, {
    path: '/oa/official/signDoc/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/signDoc/edit/edit.vue'], resolve) //签报编辑
  }, {
    path: '/oa/official/signDoc/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/signDoc/view/view.vue'], resolve) //签报详情
  }, {
    path: '/oa/official/opinion/:self',
    component: resolve => require(['@/components/oa/view/official/opinion/list/list.vue'], resolve) //意见稿
  }, {
    path: '/oa/official/opinion/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/opinion/edit/edit.vue'], resolve) //意见稿编辑
  }, {
    path: '/oa/official/opinion/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/opinion/view/view.vue'], resolve) //意见稿详情
  }, {
    path: '/oa/official/rePort/:self',
    component: resolve => require(['@/components/oa/view/official/rePort/list/list.vue'], resolve) //报表
  }, {
    path: '/oa/official/rePort/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/rePort/edit/edit.vue'], resolve) //报表编辑
  }, {
    path: '/oa/official/rePort/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/rePort/view/view.vue'], resolve) //报表详情
  }, {
    path: '/oa/official/task/:self',
    component: resolve => require(['@/components/oa/view/official/task/list/list.vue'], resolve) //交办任务
  }, {
    path: '/oa/official/task/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/task/edit/edit.vue'], resolve) //交办任务编辑
  }, {
    path: '/oa/official/task/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/task/view/view.vue'], resolve) //交办任务详情
  }, {
    path: '/oa/official/leave/:self',
    component: resolve => require(['@/components/oa/view/official/leave/list/list.vue'], resolve) //请休假
  }, {
    path: '/oa/official/leave/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/leave/edit/edit.vue'], resolve) //请休假编辑
  }, {
    path: '/oa/official/leave/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/leave/view/view.vue'], resolve) //请休假详情
  }, {
    path: '/oa/official/business/:self',
    component: resolve => require(['@/components/oa/view/official/business/list/list.vue'], resolve) //出差
  }, {
    path: '/oa/official/business/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/business/edit/edit.vue'], resolve) //出差编辑
  }, {
    path: '/oa/official/business/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/business/view/view.vue'], resolve) //出差详情
  }, {
    path: '/oa/official/overtime/:self',
    component: resolve => require(['@/components/oa/view/official/overtime/list/list.vue'], resolve) //加班
  }, {
    path: '/oa/official/overtime/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/overtime/edit/edit.vue'], resolve) //加班编辑
  }, {
    path: '/oa/official/overtime/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/overtime/view/view.vue'], resolve) //加班详情
  }, {
    path: '/oa/official/duty/:self',
    component: resolve => require(['@/components/oa/view/official/duty/list/list.vue'], resolve) //值班
  }, {
    path: '/oa/official/duty/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/duty/edit/edit.vue'], resolve) //值班编辑
  }, {
    path: '/oa/official/duty/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/duty/view/view.vue'], resolve) //值班详情
  }, {
    path: '/oa/official/compensatory/:self',
    component: resolve => require(['@/components/oa/view/official/compensatory/list/list.vue'], resolve) //补休
  }, {
    path: '/oa/official/compensatory/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/compensatory/edit/edit.vue'], resolve) //补休编辑
  }, {
    path: '/oa/official/compensatory/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/compensatory/view/view.vue'], resolve) //补休详情
  }, {
    path: '/oa/official/info/:self',
    component: resolve => require(['@/components/oa/view/official/info/list/list.vue'], resolve) //信息
  }, {
    path: '/oa/official/info/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/info/edit/edit.vue'], resolve) //信息编辑
  }, {
    path: '/oa/official/info/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/official/info/view/view.vue'], resolve) //信息详情
  }, {
    path: '/oa/meeting/room',
    component: resolve => require(['@/components/oa/view/meeting/room/list.vue'], resolve) //会议室管理
  }, {
    path: '/oa/meeting/motion/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/meeting/motion/edit/edit.vue'], resolve) //议题
  }, {
    path: '/oa/meeting/motion/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/meeting/motion/view/view.vue'], resolve) //议题详情
  }, {
    path: '/oa/meeting/motion',
    component: resolve => require(['@/components/oa/view/meeting/motion/list/list.vue'], resolve) //议题管理
  }, {
    path: '/oa/meeting/sign/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/meeting/sign/edit/edit.vue'], resolve) //议题报签
  }, {
    path: '/oa/meeting/sign/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/meeting/sign/view/view.vue'], resolve) //议题详情
  }, {
    path: '/oa/meeting/sign',
    component: resolve => require(['@/components/oa/view/meeting/sign/list/list.vue'], resolve) //议题报签管理
  }, {
    path: '/oa/meeting/minutes/edit/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/meeting/minutes/edit/edit.vue'], resolve) //会议纪要编辑
  }, {
    path: '/oa/meeting/minutes/view/:taskKey/:key',
    component: resolve => require(['@/components/oa/view/meeting/minutes/view/view.vue'], resolve) //会议纪要详情
  }, {
    path: '/oa/meeting/minutes',
    component: resolve => require(['@/components/oa/view/meeting/minutes/list/list.vue'], resolve) //会议纪要管理
  }, {
    path: '/oa/meeting/myMeeting',
    component: resolve => require(['@/components/oa/view/meeting/myMeeting/list/list.vue'], resolve) //我的会议
  }, {
    path: '/oa/supervise/edit/:key',
    component: resolve => require(['@/components/oa/view/supervise/supervise/edit/edit.vue'], resolve) //督查督办编辑
  }, {
    path: '/oa/supervise/view/:key',
    component: resolve => require(['@/components/oa/view/supervise/supervise/view/view.vue'], resolve) //督查督办详情
  }, {
    path: '/oa/supervise',
    component: resolve => require(['@/components/oa/view/supervise/supervise/list/list.vue'], resolve) //督查督办管理
  }, {
    path: '/oa/mySupervise/:self',
    component: resolve => require(['@/components/oa/view/supervise/supervise/list/list.vue'], resolve) //督查督办管理
  }, {
    path: '/oa/mySupervise/edit/:key/:self',
    component: resolve => require(['@/components/oa/view/supervise/supervise/edit/edit.vue'], resolve)//督查督办管理
  }, {
    path: '/oa/supervise/notifi',
    component: resolve => require(['@/components/oa/view/supervise/supervise/notifi/list.vue'], resolve) //督办通报
  }, {
    path: '/oa/leaveStat',
    component: resolve => require(['@/components/oa/view/stat/leave/list.vue'], resolve) //休假统计
  }, {
    path: '/oa/overtimeStat',
    component: resolve => require(['@/components/oa/view/stat/overtime/list.vue'], resolve) //加班统计
  },  {
    path: '/oa/overtimeQuery',
    component: resolve => require(['@/components/oa/view/stat/overtime/query/list.vue'], resolve) //加班查询
  },{
    path: '/oa/dutyStat',
    component: resolve => require(['@/components/oa/view/stat/duty/list.vue'], resolve) //值班统计
  }, {
    path: '/oa/official/archives',
    component: resolve => require(['@/components/oa/view/official/archives/main.vue'], resolve) //档案中心
  }, {
    path: '/oa/fileTemp',
    component: resolve => require(['@/components/oa/view/official/fileTemplate/list.vue'], resolve) //文件模板
  },  {
    path: '/oa/notice/:self',
    component: resolve => require(['@/components/oa/view/meeting/notice/list/list.vue'], resolve) //参会通知
  }, {
    path: '/oa/notice/edit/:key/:type',
    component: resolve => require(['@/components/oa/view/meeting/notice/edit/edit.vue'], resolve) //参会通知编辑
  }, {
    path: '/oa/notice/view/:key',
    component: resolve => require(['@/components/oa/view/meeting/notice/view/view.vue'], resolve) //参会通知详情
  }, {
    path: '/oa/opinion/temp',
    component: resolve => require(['@/components/oa/view/basics/opinionTemp/list.vue'], resolve) //快捷意见
  }, {
    path: '/oa/noticeInfo',
    component: resolve => require(['@/components/oa/view/basics/noticeInfo/list/list.vue'], resolve) //通知公告
  }, {
    path: '/oa/noticeInfo/edit/:key',
    component: resolve => require(['@/components/oa/view/basics/noticeInfo/edit/edit.vue'], resolve) //通知公告编辑
  }, {
    path: '/oa/noticeInfo/view/:key',
    component: resolve => require(['@/components/oa/view/basics/noticeInfo/view/view.vue'], resolve) //通知公告详情
  }, {
    path: '/oa/myNoticeInfo',
    component: resolve => require(['@/components/oa/view/basics/noticeInfo/myList/list.vue'], resolve) //我的通知公告
  }, {
    path: '/oa/lead/mail',
    component: resolve => require(['@/components/oa/view/mail/list/list.vue'], resolve) //领导邮箱管理
  }, {
    path: '/oa/lead/info',
    component: resolve => require(['@/components/oa/view/mail/lead/lead.vue'], resolve) //领导信息管理
  }, {
    path: '/oa/official/history',
    component: resolve => require(['@/components/oa/view/official/history/list.vue'], resolve) //历史档案
  },{
    path: '/oa/workAccount',
    component: resolve => require(['@/components/oa/view/meeting/workAccount/list/list.vue'], resolve) //工作台账管理
  },{
    path: '/oa/work/fillIn',
    component: resolve => require(['@/components/oa/view/meeting/workAccount/fillIn/list.vue'], resolve) //工作台账填报
  },{
    path: '/oa/leaveConfig',
    component: resolve => require(['@/components/oa/view/basics/leaveConfig/list.vue'], resolve) //请休假配置
  },
  {
    path: '/oa/qx/receive',
    component: resolve => require(['@/components/oa/view/official/receive/qx/edit/edit.vue'], resolve) //区县收文登记
  },
  {
    path: '/oa/qx/receiveList',
    component: resolve => require(['@/components/oa/view/official/receive/qx/list/list.vue'], resolve) //区县收文列表
  },{
    path: '/oa/qx/copyList/:type',
    component: resolve => require(['@/components/oa/view/official/receive/copyList/list.vue'], resolve) //交办传阅件
  },{
    path: '/oa/leaderStat',
    component: resolve => require(['@/components/oa/view/stat/leader/list.vue'], resolve) //加班统计
  },{
    path: '/oa/policyClassify',
    component: resolve => require(['@/components/oa/view/basics/policyClassify/list.vue'], resolve) //政策法规分类管理
  },{
    path: '/oa/policyLibrary',
    component: resolve => require(['@/components/oa/view/basics/policyClassify/library/list.vue'], resolve) //政策法规文件
  },{
    path: '/basics/wait',
    component: resolve => require(['@/components/oa/view/basics/wait/list.vue'], resolve) //待办件
  },{
    path: '/basics/tracking',
    component: resolve => require(['@/components/oa/view/basics/tracking/list.vue'], resolve) //办理追踪
  },{
    path: '/basics/copy/:type',
    component: resolve => require(['@/components/oa/view/basics/copy/list.vue'], resolve) //传阅处理
  }
]
},{
  path: '/oa/meeting/view/:key',
  component: resolve => require(['@/components/oa/view/meeting/myMeeting/view/view.vue'], resolve) //会议界面
}, {
  path: '/oa/official/sendDoc/print/:key',
  component: resolve => require(['@/components/oa/view/official/sendDoc/print/print.vue'], resolve) //发文打印单
}, {
  path: '/oa/official/receive/print/:key',
  component: resolve => require(['@/components/oa/view/official/receive/print/print.vue'], resolve) //收文打印单
}, {
  path: '/oa/official/opinion/print/:key',
  component: resolve => require(['@/components/oa/view/official/opinion/print/print.vue'], resolve) //意见稿打印单
}, {
  path: '/oa/official/leave/print/:key',
  component: resolve => require(['@/components/oa/view/official/leave/print/print.vue'], resolve) //请休假打印单
}, {
  path: '/oa/official/business/print/:key',
  component: resolve => require(['@/components/oa/view/official/business/print/print.vue'], resolve) //出差打印单
}, {
  path: '/oa/official/overtime/print/:key',
  component: resolve => require(['@/components/oa/view/official/overtime/print/print.vue'], resolve) //加班打印单
},{
  path: '/oa/fileTemp/choose/:bizType',
  component: resolve => require(['@/components/oa/view/official/fileTemplate/choose/choose.vue'], resolve) //文件模板
},
{
  path: '/oa/office/browerDialog',
  component: resolve => require(['@/components/oa/view/webOffice/browserDialog/edit.vue'], resolve) //浏览器弹窗打开插件
}
]



// WEBPACK FOOTER //
// ./src/components/oa/router/router.js